import React from 'react';
import { textareaStyle } from '../../tokens';
import Field from '../Field';

export default function DmNodeEditor({ body, onBodyChange, error, label = 'Message' }) {
  return (
    <Field label={label}>
      <textarea
        style={{ ...textareaStyle, minHeight: 140, borderColor: error ? '#DC2626' : undefined }}
        value={body || ''}
        onChange={(e) => onBodyChange(e.target.value)}
        placeholder="Hi {{name}}&#10;&#10;Thank you for your interest."
      />
      {error && <div style={{ fontSize: 11, color: '#DC2626', marginTop: 4 }}>{error}</div>}
    </Field>
  );
}
